import { useLocation } from 'react-router-dom'

/**
 * Determines if the current URL matches any paths in a provided list.
 *
 * @param pathList - An array of paths to be checked against the current URL.
 *
 * @returns Returns `true` if the current URL matches any path from the list, `false` otherwise.
 *
 * @example
 *
 * const isActive = useIsActiveUrl(['/billing', '/products/resolve-trial']);
 */
const useIsActiveUrl = (pathList: string[]): boolean => {
  const location = useLocation()
  const pathWithoutAccountKey = location.pathname.replace(/^\/\d*/, '')

  return pathList.map((path) => new RegExp(`^${path}(?:/|$)`)).some((pattern) => pattern.test(pathWithoutAccountKey))
}

export default useIsActiveUrl
